/**
 * Created by xiaojielin on 17/1/1.
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/Home.vue'
import Form from '../view/Form.vue'
import Me from '../view/Me.vue'
import Card from '../view/Card'
import Profile from '../view/Profile'

Vue.use(Router)

const routes = [
  { path: '/', redirect: '/Home' },
  { path: '/Home', component: Home },
  { path: '/Form', component: Form },
  { path: '/Me', component: Me },
  { path: '/Card', component: Card },
  { path: '/Profile', component: Profile }
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes // （缩写）相当于 routes: routes
})



// WEBPACK FOOTER //
// ./src/conf/router.js